import { config } from "@/config/env";
import axios from "axios";
import { getCurrentJWT } from "utils/tokens/tokenHelpers";

export enum ClaimIds {
  CLUBHOUSE_ADMIN = "clubhouse-admin",
}

export async function fetchUserClaim(claimId?: string) {
  const token = getCurrentJWT();
  if (!token) return [];

  const url = `${config.apiBaseUrl}/api/roles/roles_for_claims`;
  const { data } = await axios.get<{ [key: string]: string }>(url, {
    headers: { authorization: `Bearer ${token}` },
  });

  if (claimId) {
    if (Object.hasOwn(data, claimId)) {
      const value: string | undefined = data[claimId];
      return value;
    }
    return "";
  } else {
    return "";
  }
}

export async function validateUserClaims(claimId: string, facilityId: string) {
  const token = getCurrentJWT();
  if (!token || !claimId) return [];

  const url = `${import.meta.env.VITE_HTTPS_PROTOCOL}${
    import.meta.env.VITE_BASE_URL
  }/api/users/check_claim?claimId=${encodeURIComponent(
    claimId,
  )}&facilityIds=${facilityId}`;
  const { data } = await axios.get<boolean>(url, {
    headers: { authorization: `Bearer ${token}` },
  });
  return data;
}

export async function hasClubhouseAdminClaim(facilityId: string) {
  const userClaim = await fetchUserClaim(ClaimIds.CLUBHOUSE_ADMIN);
  if (!userClaim) return false;

  const validateClaims = await validateUserClaims(
    userClaim as string,
    facilityId,
  ).then((res) => res as boolean);

  return validateClaims;
}
